var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.3369 8.47363V32.1999","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M32.1999 20.3369L20.3368 32.2001L8.47363 20.3369","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowDown.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
